/**
 * If there's only a single practitioner, this larger bio is shown.
 */
import React, {CSSProperties} from "react";
import './Provider.css';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {ActionButton} from "../../util/UI/ActionButton";
import {IProviderSearchResult} from "../../compiled";
import {useNavigate} from "react-router-dom";
import {formatUrl} from "../../util/UrlUtil";

const carouselConfig = {
  desktop: {
    breakpoint: {max: 3000, min: 900},
    items: 3,
    slidesToSlide: 3, // optional, default to 1.
  },
  middle: {
    breakpoint: {max: 1000, min: 700},
    items: 2,
    slidesToSlide: 2, // optional, default to 1.
  },
  mobile: {
    breakpoint: {max: 700, min: 0},
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  }
};

const carouselTwoItemMax = {
  middle: {
    breakpoint: {max: 3000, min: 700},
    items: 2,
    slidesToSlide: 2, // optional, default to 1.
  },
  mobile: {
    breakpoint: {max: 700, min: 0},
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  }
};

/**
 * This gets used in a provider's page to show all their practitioners AND
 * recommended providers on the home page.
 */
export const BusinessCarousel = (props: { businesses: IProviderSearchResult[] }) => {
  return <Carousel
      draggable={true}
      showDots={false}
      swipeable={true}
      responsive={props.businesses.length <= 2 ? carouselTwoItemMax : carouselConfig}
      containerClass="carousel-container"
      dotListClass="carousel-dot-list"
      itemClass="carousel-item">
    {props.businesses.map(business => {
      return <CarouselItem key={business.businessId} business={business}/>
    })}
  </Carousel>
}

const CarouselItem = (props: { business: IProviderSearchResult }) => {

  const navigate = useNavigate();

  const businessProfile = props.business.businessProfile;
  return <div className={'BusinessCarousel'}>
    <div className={'BusinessCarouselContent'}>
      <div className={'BusinessCarouselImageMask'}>
        <img className={'BusinessCarouselImage'} src={businessProfile?.imageUrl ?? ''}/>
      </div>
      <div className={'BusinessCarouselName'}>{businessProfile?.businessName}</div>
      <div className={'BusinessCarouselDescription'}>{businessProfile?.businessDescription}</div>
      <div className={'BusinessCarouselButtons'}>
        {businessProfile?.imageUrl &&
            <a href={formatUrl(props.business.businessProfile?.websiteUrl)} target={'_blank'}>
              <ActionButton smaller secondary>
                WEBSITE
              </ActionButton>
            </a>}

        {businessProfile?.hasBooking &&
            <a href={`/book?b=` + props.business.businessId}>
              <ActionButton smaller>
                BOOK NOW
              </ActionButton>
            </a>
        }
      </div>
    </div>
  </div>
}

